// GoogleDriveAccess.jsx        контейнер-сторінка (склеює все)

// docker exec -it alpha-web bash
// tail -f /var/log/apache2/error.log

// cd D:\www\PHPandReact\GoogleDriveAccess\.dev\.docker
//  docker compose down
//  docker compose up --build -d

// Ввімкнення сайту й модулів
// sudo a2enmod rewrite ssl headers
// sudo a2ensite alpha.lc
// sudo systemctl reload apache2

// Права доступу
// sudo chown -R www-data:www-data /var/www/alpha
// sudo find /var/www/alpha -type d -exec chmod 755 {} \;
// sudo find /var/www/alpha -type f -exec chmod 644 {} \;

// Відкликання доступу
// у додатку у Google Account → Security → Third-party access

// Перезапуск MySQL https://chatgpt.com/s/t_68aa31d27ed08191b73077a361b2ce3c
//                  https://chatgpt.com/s/t_68aab1ba46d081918f7323568d135e9c
//                  https://chatgpt.com/s/t_68aa288707348191b03e8761cb233d70  -   тут створення таблиці MeSQL, інші дії з помилками

// .\mysqld --console --defaults-file="C:\WebServer\MySQL\my.ini" - помилка
// .\mysqld --defaults-file="C:/WebServer/MySQL/my.ini" --console - треба так


// git remote add origin https://github.com/KomlievOleh/GoogleDriveAccess.git
// git branch -M main
// git push -u origin main


import React, { useMemo, useState, useRef } from 'react';
import Toolbar from './Toolbar';
import TreeSidebar from './TreeSidebar';
import GallerySection from './Gallery/GallerySection';
import Lightbox from './Lightbox/Lightbox';
import UploadToolbar from './Uploading/UploadToolbar';
import ShowFolderPicker from './Uploading/ShowFolderPicker';
import useLightbox from '../../hooks/useLightbox';
import useUpLoading from '../../hooks/useUpLoading';
import useDriveSession from '../../hooks/useDriveSession';
import useDriveApi from '../../hooks/useDriveApi';
import service from '../../lib/service';
import google from '../../constants/google';
import useFeatures from '../../hooks/useFeatures';

const FOLDER_MIME = google.FOLDER_MIME;
const SHORTCUT_MIME = google.SHORTCUT_MIME;

// 🔹 helper для читання куки drive_access
const DRIVE_ACCESS_COOKIE = 'drive_access';
function getCookie(name) {
    if (typeof document === 'undefined') return null;
    const escaped = name.replace(/([$.?*|{}()[\]\\/+^])/g, '\\$1');
    const match = document.cookie.match(
        new RegExp('(?:^|; )' + escaped + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
}
function getDriveAccess() {
    const v = getCookie(DRIVE_ACCESS_COOKIE);
    return v === 'read' ? true : false;
}

export default function GoogleDriveAccess() {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [folderId, setFolderId] = useState('');
    const [authed, setAuthed] = useState(false);
    // const [path, setPath] = useState([{ id: 'root', name: 'Мій диск' }]);
    const [path, setPath] = useState([{}]);
    const [tree, setTree] = useState({});
    const [expanded, setExpanded] = useState({});

    // dedupe/кеш для списків
    const filesCacheRef = useRef(new Map()); // Map<folderId, files[]>
    const inflightRef = useRef(new Map()); // Map<folderId, Promise<files[]>>

    // окремий кеш лише для “дітей-папок” у дереві
    const folderKidsCacheRef = useRef(new Map()); // Map<folderId, [{id,name}]>
    const kidsInflightRef = useRef(new Map()); // Map<folderId, Promise<Array>>

    const [flatMode, setFlatMode] = useState(false); // вмикач плоского перегляду

    const [roots, setRoots] = useState([]);    // масив коренів forest [{id,name},...]
    const [showTree, setShowTree] = useState(false);

    const serv = service();
    const sortAscByMtime = serv.sortAscByMtime;

    const fmgr = useFeatures();

    const isReadOnly = useMemo(() => getDriveAccess(), []);

    const folders = useMemo(() => files.filter(f => f.type === FOLDER_MIME || f.type === SHORTCUT_MIME), [files]);
    const images = useMemo(() => files.filter(serv.isImageFile), [files]);
    const videos = useMemo(() => files.filter(serv.isVideoFile), [files]);
    const pdfs = useMemo(() => files.filter(serv.isPdf), [files]);

    const driveSession = useDriveSession({
        setAuthed, setFiles, setError, setPath, setTree, setRoots,
        serv, setShowTree,
        setExpanded, filesCacheRef, inflightRef, folderKidsCacheRef, kidsInflightRef,
        featuresManager: fmgr,
    });

    const resetSession = driveSession.resetSession;

    const driveApi = useDriveApi({
        tree, setTree, folderId, setFolderId, expanded, setExpanded, flatMode, setLoading, setPath, setError,
        setFiles, filesCacheRef, inflightRef, kidsInflightRef, folderKidsCacheRef, resetSession, sortAscByMtime,
        featuresManager: fmgr,
    });

    const lb = useLightbox({ images, videos, pdfs });

    const uploadLb = useUpLoading({ path, setPath, folderId, driveApi, setError, serv });

    return (
        <div className="p-6 max-w-7xl mx-auto">
            <Toolbar
                authed={authed}
                onLogout={driveSession.handleLogout}
                fmgr={fmgr}
                loadForest={driveSession.loadForest}
            />
            {/* 🔹 UploadToolbar показуємо тільки якщо не read-only */}
            {authed && !isReadOnly && (
                <UploadToolbar
                    authed={authed}
                    uploadLb={uploadLb}
                />
            )}
            {authed && isReadOnly && (
                <div className="mb-3 text-sm text-slate-600">
                    <strong>R</strong>
                </div>
            )}

            {error && <div className="bg-red-100 text-red-700 p-3 mb-3 rounded-md">{String(error)}</div>}

            {authed && (
                <div className="grid grid-cols-1 md:grid-cols-[300px,1fr] gap-4">
                    <TreeSidebar
                        roots={roots}
                        tree={tree}
                        showTree={showTree}
                        expanded={expanded}
                        flatMode={flatMode}
                        setFlatMode={setFlatMode}
                        toggleNode={driveApi.toggleNode}
                        ensureChildren={driveApi.ensureChildren}
                        onEnter={driveApi.enterFolder}
                        onOpenItem={(item, type, nodes) => lb.openAt(item, type, nodes)}
                    />
                    <GallerySection
                        path={path}
                        authed={authed}
                        folders={folders}
                        images={images}
                        videos={videos}
                        pdfs={pdfs}
                        files={files}
                        flatMode={flatMode}
                        loading={loading}
                        enterFolder={driveApi.enterFolder}
                        onOpenItem={(item, type) => lb.openAt(item, type)}
                        onDeleteItems={(items, options) => uploadLb.deleteFile(items, options)}
                        onMoveItems={uploadLb.moveFile}
                        uploadLb={uploadLb}
                        driveApi={driveApi}
                        setError={setError}
                        isReadOnly={isReadOnly}
                    />
                </div>
            )}
            <Lightbox
                images={lb.viewImages}
                videos={lb.viewVideos}
                pdfs={lb.viewPdfs}
                lb={lb}
            />
            <ShowFolderPicker
                uploadLb={uploadLb}
            />
        </div>
    );
}

